export const faqsTypes = {
    FAQ_ONCHANGE: "FAQ_ONCHANGE",
    SELECTED_FAQS: "SELECTED_FAQS",
    ALL_SELECTED_FAQS:"ALL_SELECTED_FAQS",
  };
  